<template>
  <v-main style="height: 100%">
    <HeaderLabel label="Brand"></HeaderLabel>
    <v-layout justify-center mt-5>
      <v-flex pa-4>
        <v-layout justify-space-between mb-7>
          <v-flex shrink>
            <v-layout>
              <v-flex>
                <v-text-field class="mr-2" v-model="keyword" dense outlined label="Keyword"></v-text-field>
              </v-flex>
              <v-flex>
                <v-btn
                  @click="search"
                  depressed
                  dense
                  large
                  color="#c80404"
                  class=" text-start white--text"
                >
                  Search
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex shrink>
            <v-btn
              @click="clickRow({})"
              depressed
              large
              color="#c80404"
              class="pr-7 text-start white--text"
            >
              <v-icon class="mr-2">mdi-plus</v-icon>
              Add
            </v-btn>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="12">
            <v-data-table :items="brandList" style="border: solid 1px black">
              <template v-slot:header="{}">
                <thead class="white--text" style="background-color: #555555">
                  <tr>
                    <td>Image</td>
                    <td>Name</td>
                    <td>Description</td>
                    <td></td>
                  </tr>
                </thead>
              </template>
              <template v-slot:item="{ item }">
                <tr :class="{ itemHide: !item.is_active }">
                  <td align="center">
                    <v-img
                      width="100px"
                      :src="
                        item.image && item.image[0]
                          ? item.image[0]
                          : require('../assets/img/no-image.png')
                      "
                    ></v-img>
                  </td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.description }}</td>
                  <td>
                    <a @click="clickRow(item)">Edit</a> |
                    <a
                      @click="toggleDisplay(item)"
                      :class="[item.is_active ? 'red--text' : 'green--text']"
                    >
                      {{ item.is_active ? "Hide" : "Show" }}
                    </a>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialog" @close="SucessClick" max-width="700" persistent>
      <div v-if="dialog" style="background-color: white">
        <BrandForm @SucessClick="SucessClick" :model="row"></BrandForm>
      </div>
    </v-dialog>
  </v-main>
</template>

<script>
import { mapState } from "vuex";
import Service from "../services";
import HeaderLabel from "../components/HeadetLabel";
import BrandForm from "../components/BrandForm";
export default {
  name: "Brand",
  data() {
    return {
      row: {},
      keyword:null,
      dialog: false,
    };
  },
  components: {
    BrandForm,
    HeaderLabel,
  },
  methods: {
    search(){
      this.$store.dispatch("Brand/getBrandList",this.keyword);
    },
    clickRow(item) {
      this.row = item;
      this.dialog = true;
    },
    async toggleDisplay(item) {
      let answer = await this.$swal.fire({
        ...this.$swalDel,
        text: `Are you sure to ${item.is_active ? "hide" : "show"} this brand?`,
      });
      if (answer.isConfirmed) {
        this.$store.dispatch("Loading/onSetLoading", true);
        Service.brand.display(item).then((res) => {
          if (res.status === 200) {
            this.$store.dispatch("Brand/getBrandList");
            this.$store.dispatch("Loading/onSetLoading", false);
          }
        });
      }
    },
    SucessClick() {
      this.dialog = false;
      this.$store.dispatch("Brand/getBrandList");
    },
  },
  computed: {
    ...mapState({
      brandList: (state) => state.Brand.brandList,
    }),
  },
  async created() {
    await this.$store.dispatch("Brand/getBrandList");
  },
};
</script>

<style>
</style>